<template>
  <textarea
    :class="getClass"
    :name="name"
    :placeholder="getPlaceholder"
    :rows="rows"
    :value="getValue"
    @blur="onBlur"
    @focus="onFocus"
    @input="onInput"
    @keydown.enter="onEnter" />
</template>

<script>
import BaseInput from './BaseInput.vue'

export default {
  name: 'BaseTextarea',

  extends: BaseInput,

  props: {
    rows: { default: 4, type: Number }
  }
}
</script>
